export default "__VITE_ASSET__Cfd_RM2l__"